import { profileActions as profile } from "src/store/profile/profile.actions";

const initialState = {
  isFetching: false,
  isFetchingPunchoutUrl: false,
  helptexts: {
    isFetching: false,
    error: false,
    helptexts: null,
    lastFetched: null
  },
  profile: null,
  has_cattle: {
    isFetching: false,
    error: false,
    has_cattle: null
  },
  is_superuser: {
    is_superuser: null,
    error: false,
    isFetching: false
  },
  prognosis_registration_config: {
    config: null,
    error: false,
    isFetching: false
  },
  prognosis_registration: {
    showPopup: false
  },
  prognosis_submitted: {
    data: null,
    error: false,
    isFetching: false
  },
  prognosis_statistics: {
    data: null,
    error: false,
    isFetching: false
  },
  prognosis_pending_registration: {
    error: false,
    isFetching: false,
    done: false
  },
  error: false,
  errorcodes: []
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case "RESET_STORE":
      return initialState;
    case profile.setIsFetchingPunchoutUrl().type:
      return {
        ...state,
        isFetchingPunchoutUrl: action.payload,
      };
    case profile.fetchHelptexts().type:
      return {
        ...state,
        helptexts: {
          ...state.helptexts,
          isFetching: true
        }
      };
    case profile.fetchHelptextsSuccess().type:
      return {
        ...state,
        helptexts: {
          ...state.helptexts,
          helptexts: action.payload.data,
          isFetching: false,
          lastFetched: new Date()
        }
      };
    case profile.fetch().type:
      return { ...state, isFetching: true, error: false };
    case profile.fetchSuccess().type:
      return {
        ...state,
        profile: action.payload.profile,
        isFetching: false,
        error: false
      };
    case profile.fetchFailure().type:
      return {
        ...state,
        profile: null,
        isFetching: false,
        error: true,
        errorcodes: action.payload.errorcodes
      };
    case profile.fetchHasCattle().type:
      return {
        ...state,
        has_cattle: { ...state.has_cattle, is_fetching: true, error: false }
      };
    case profile.fetchHasCattleSuccess().type:
      return {
        ...state,
        has_cattle: {
          ...state.has_cattle,
          has_cattle: action.payload.has_cattle,
          is_fetching: false,
          error: false
        }
      };
    case profile.fetchHasCattleFailure().type:
      return {
        ...state,
        has_cattle: {
          ...state.has_cattle,
          has_cattle: null,
          is_fetching: false,
          error: true
        }
      };
    case profile.fetchIsSuperuser().type:
      return {
        ...state,
        is_superuser: {
          ...state.is_superuser,
          isFetching: true,
          is_superuser: null,
          error: false
        }
      };
    case profile.fetchIsSuperuserSuccess().type:
      return {
        ...state,
        is_superuser: {
          ...state.is_superuser,
          isFetching: false,
          is_superuser: action.payload.is_superuser === true,
          error: false
        }
      };
    case profile.fetchIsSuperuserFailure().type:
      return {
        ...state,
        is_superuser: {
          ...state.is_superuser,
          isFetching: false,
          is_superuser: null,
          error: true
        }
      };
    case profile.save().type:
      return { ...state, isFetching: true, error: false };
    case profile.saveSuccess().type:
      return {
        ...state,
        profile: { ...profile, ...action.payload.new_changed_fields },
        error: false,
        isFetching: false
      };
    case profile.saveFailure().type:
      return {
        ...state,
        isFetching: false,
        error: true,
        errorcodes: action.payload.errorcodes
      };

    case profile.fetchPrognosisRegistrationConfig().type:
      return {
        ...state,
        prognosis_registration_config: {
          ...state.prognosis_registration_config,
          isFetching: true,
          error: false
        }
      };
    case profile.fetchPrognosisRegistrationConfigSuccess().type:
      return {
        ...state,
        prognosis_registration_config: {
          ...state.prognosis_registration_config,
          config: action.payload.config
        },
        prognosis_registration: {
          ...state.prognosis_registration,
            showPopupNow: state.prognosis_registration.showPopupNow || action.payload.showPopupNow 
        },
        error: false,
        isFetching: false
      };
    case profile.fetchPrognosisRegistrationConfigFailure().type:
      return {
        ...state,
        prognosis_registration_config: {
          config: null,
          isFetching: false,
          error: true,
          errorcodes: action.payload.errorcodes
        }
      };
    case profile.fetchPrognosisSubmitted().type:
      return {
        ...state,
        prognosis_submitted: {
          ...state.prognosis_submitted,
          isFetching: true,
          error: false
        }
      };
    case profile.fetchPrognosisSubmittedSuccess().type:
      return {
        ...state,
        prognosis_submitted: {
          ...state.prognosis_submitted,
          data: action.payload.data,
          error: false,
          isFetching: false
        }
      };
    case profile.fetchPrognosisSubmittedFailure().type:
      return {
        ...state,
        prognosis_submitted: {
          config: null,
          isFetching: false,
          error: true,
          errorcodes: action.payload.errorcodes
        }
      };


      case profile.fetchPrognosisStatistics().type:
        return {
          ...state,
          prognosis_statistics: {
            ...state.prognosis_statistics,
            isFetching: true,
            error: false
          }
        };
      case profile.fetchPrognosisStatisticsSuccess().type:
        return {
          ...state,
          prognosis_statistics: {
            ...state.prognosis_statistics,
            data: {...state.prognosis_statistics.data, [action.payload.animalKind]: action.payload.data[action.payload.animalKind]},
            error: false,
            isFetching: false
          }
        };
      case profile.fetchPrognosisStatisticsFailure().type:
        return {
          ...state,
          prognosis_statistics: {
            config: null,
            isFetching: false,
            error: true,
            errorcodes: action.payload.errorcodes
          }
        };

      
    case profile.registerPrognosis().type:
      return {
        ...state,
        prognosis_pending_registration: {
          ...state.prognosis_pending_registration,
          isFetching: true,
          done: false,
          error: false
        }
      };
    case profile.registerPrognosisSuccess().type:
      return {
        ...state,
        prognosis_pending_registration: {
          ...state.prognosis_pending_registration,
          error: false,
          done: true,
          isFetching: false
        }
      };
    case profile.registerPrognosisFailure().type:
      return {
        ...state,
        prognosis_pending_registration: {
          isFetching: false,
          error: true,
          done: false,
          errorcodes: action.payload.errorcodes
        }
      };
    case profile.openPrognosisRegistration().type:
      return {
        ...state,
        prognosis_registration: {
          ...state.prognosis_registration,
          showPopupNow: true
        }
      };
    case profile.closePrognosisRegistration().type:
      return {
        ...state,
        prognosis_registration: {
          ...state.prognosis_registration,
          showPopupNow: false
        },
        prognosis_submitted: {
          ...initialState.prognosis_submitted
        },
        prognosis_pending_registration: {
          ...initialState.prognosis_pending_registration
        }
      };

    default:
      return state;
  }
};

export default profileReducer;
